<label role="button" tabindex="0">
    <input type="radio" tabindex="-1" [name]="_parent.name" [value]="value" [(ngModel)]="_parent.value" />
    <mg-ui-checkmark></mg-ui-checkmark>
</label>
